import io from 'socket.io-client';

// Biến toàn cục cho URL API và Socket
export const API_URL ='https://api.abcshoppinglouis.com';
export const SOCKET_URL = 'https://sk.abcshoppinglouis.com';

// export const API_URL ='http://localhost:3008';
// export const SOCKET_URL = 'http://localhost:1448';

const socket = io(SOCKET_URL);

export default socket;
